import SiteMap from '../cms-components/blackrock/advisor-center/site-map/SiteMap';

export const SiteMapComponent = SiteMap;
